import React, { useContext, useState } from 'react';
import { UserEntityContextProps, UserEntityProviderProps } from './types';
import humps from 'humps';
import { getJSON, handleError } from '../../utils/FetchUtils';
import { getActiveEntityId, getActiveUserId } from '../../actions/AuthedActions';
import { toastr } from 'react-redux-toastr';
import Auth from 'app/utils/Auth';
import useSWR from 'swr';

export const UserEntityContext = React.createContext({});

const UserEntityProvider: React.FC<UserEntityProviderProps> = ({ children }) => {
    const [data, setData] = useState({});
    const [userLoading, setUserLoading] = useState(false);

    const handleSetSubGroup = (userData: any) => {
        const { subgroups = [] } = userData || {};
        if (subgroups?.[0]) Auth.setSubGroup(subgroups?.[0]);
        else Auth.removeSubGroup();
    };

    const getUser = () => {
        const url = `${process.env.REACT_APP_AUTH_API_HOST}/entities/${getActiveEntityId()}/users/${getActiveUserId()}?product_id=CRDPL`;
        setUserLoading(true);
        try {
            return getJSON(url).then((d) => humps.camelizeKeys(d));
        } catch (e) {
            setUserLoading(false);
            return handleError(e).then((err: string) => err);
        }
    };

    const getUserDetails = () => {
        getUser()
            .then((d: any) => {
                setData(d);
                handleSetSubGroup(d);
                setUserLoading(false);
            })
            .catch((e: any) => {
                setUserLoading(false);
                handleError(e).then(() => {
                    toastr.error('Error Occured', e);
                });
            });
    };
    useSWR(`user-detail`, getUserDetails);

    return <UserEntityContext.Provider value={{ data, userLoading }}>{children}</UserEntityContext.Provider>;
};

export const useUserEntityContext = (): UserEntityContextProps => {
    return useContext(UserEntityContext) as UserEntityContextProps;
};

export const useUser = (): any => {
    const { user = {} } = useContext(UserEntityContext) as UserEntityContextProps;
    return user;
};

export default UserEntityProvider;
